<div class="availability-container">
  <div class="sidebar">
    <div class="apply-row">
      <h3>Apply to:</h3>

      <p class="small-text subtle-text">
        {{ (selectedRestaurants.size) }} selected
      </p>
    </div>

    <kendo-textbox
      [placeholder]="'Search by Restaurant No., Tier, DMA or City'"
      class="m-b-4"
      (valueChange)="handleFilter($event)"
    >
      <ng-template kendoPrefixTemplate>
        <button kendoButton fillMode="flat">
          <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
        </button>
      </ng-template>
    </kendo-textbox>

    <div class="k-d-flex">
      <kendo-checkbox
      class="m-t-4 m-r-2"
      (checkedStateChange)="
      toggleSelectAllTieredRestaurants($event)
      "
      [checkedState]="allTieredRestaurantsSelected"
      ></kendo-checkbox>
      <p> {{ allTieredRestaurantsSelected ? 'Unselect All' : 'Select All' }} </p>
    </div>

    <div class="no-assigned-restaurants" *ngIf="hasNoAssignedRestaurants">
      <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
      <p class="m-0">
        You don't have any restaurants assigned. Please contact your
        administrator to have restaurants assigned to your user in RSIWeb.
      </p>
    </div>

    <div class="content">
      <kendo-chiplist selection="multiple">
        <kendo-chip
          kendoTooltip
          [attr.aria-selected]="restaurant.selected"
          (click)="toggleRestaurantSelect(restaurant);"
          fillMode="outline"
          *ngFor="let restaurant of tieredRestaurants"
        >
          <span
            class="custom-content"
            [title]="
              restaurant.priceTierName +
              ' | ' +
              restaurant.cityName +
              ' | ' +
              restaurant.dmaName
            "
          >
            <kendo-checkbox
              [checkedState]="restaurant.selected"
            ></kendo-checkbox>

            <kendo-label class="restaurant-name-label">
              {{ restaurant.name }}
            </kendo-label>
            <button
              *ngIf="restaurant.isKing"
              kendoButton
              [disabled]="true"
              fillMode="clear"
              size="none"
              class="king-icon"
              themeColor="primary"
            >
              <fa-icon [icon]="['fas', 'crown']"></fa-icon>
            </button>
          </span>
        </kendo-chip>
      </kendo-chiplist>
    </div>
  </div>

  <div class="grid">
    <p
      class="m-0 thin-text italic-text justify-center content-align-center height-100"
      *ngIf="!showingDataFor"
    >
      {{
        hasNoAssignedRestaurants
          ? 'No restaurants assigned to your user'
          : 'Select at least one restaurant to see availability data'
      }}
    </p>
    <div
      *ngIf="showingDataFor && component"
      class="k-toolbar k-grid-toolbar custom-toolbar"
    >
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="productTypes"
          [(ngModel)]="productType"
          textField="name"
          valueField="id"
        ></kendo-dropdownlist>
        <kendo-dropdownlist
          [data]="categories"
          [(ngModel)]="selectedCategory"
          textField="name"
          valueField="id"
          (ngModelChange)="updateParameters()"
          [defaultItem]="defaultCategory"
        ></kendo-dropdownlist>
        <kendo-dropdownlist
          [data]="machineTypes"
          [(ngModel)]="selectedMachineType"
          textField="name"
          valueField="id"
          (ngModelChange)="updateParameters()"
          [defaultItem]="defaultMachineType"
        ></kendo-dropdownlist>
      </div>
      <div class="buttons-section">
        <button
          kendoButton
          size="small"
          fillMode="outline"
          (click)="saveBulkFilteredChanges(false)"
          themeColor="error"
          [disabled]="!hasFiltersOrData()"
          *ngIf="hasFiltersOrData()"
          kendoTooltip
          title="Turn off all items matching current filters (across all pages)"
        >
          Turn off
        </button>
        <button
          kendoButton
          size="small"
          fillMode="outline"
          (click)="saveBulkFilteredChanges(true)"
          themeColor="success"
          [disabled]="!hasFiltersOrData()"
          *ngIf="hasFiltersOrData()"
          kendoTooltip
          title="Turn on all items matching current filters (across all pages)"
        >
          Turn on
        </button>
        <kendo-badge-container>
          <button
            kendoButton
            size="small"
            fillMode="outline"
            [disabled]="component.cache.size == 0"
            (click)="saveChanges()"
            themeColor="primary"
          >
            Save
          </button>
          <kendo-badge
            *ngIf="(component?.cache?.size ?? 0) > 0"
            size="small"
            rounded="full"
            [align]="{ vertical: 'top', horizontal: 'end' }"
            themeColor="success"
            >{{ component.cache.size }}</kendo-badge
          >
        </kendo-badge-container>
        <app-grid-manager-toolbar
          [showConfig]="false"
          (exportToExcel)="exportToExcel($event)"
          [showExport]="['Current Type']"
          [showImport]="hasWriteAccess ? ['Current Type'] : []"
          (uploadSuccessful)="updatePendingChanges()"
          [fontSize]="component.fontSize"
          (fontSizeChange)="updateFontSize($event)"
          [columns]="component.columns"
          [importUrl]="component.importUrls"
          view="availability"
          ><ng-template #configurationTemplate
            ><app-configuration></app-configuration></ng-template
        ></app-grid-manager-toolbar>
      </div>
    </div>
    <router-outlet *ngIf="showingDataFor" (activate)="onActivate($event)"></router-outlet>
  </div>
</div>
